import { ProductIndexItemInterface } from "../shared/ProductIndexItemInterface";
import { ProductPriceInterface } from "../shared/ProductPriceInterface";

export interface ProductAssociationCardInterface extends ProductIndexItemInterface {
    productFamily: {
        code: string;
        label: string;
    };
    prices: ProductPriceInterface | null;
    productState: string;
    similarProductsSpecification?: {
        code: string;
        label: string;
        value: string;
    };
}

export interface ProductAssociationOldModelInterface {
    id: number;
    identifier: string;
    label: string;
    image: string;
    expirationYear: {
        code: string;
        label: string | null;
        value: string | null;
    } | null;
}

export interface ProductOlderModelAssociationInterface {
    id: number;
    label: string;
    image: string;
    expirationYear: { label: string; value: string } | null;
    identifier: string;
}

export interface ProductAddOnCardInterface {
    id: number;
    identifier: string;
    label: string | null;
    image: string | null;
    prices: ProductPriceInterface | null;
}

export interface ProductAssociatedInterface {
    old_model?: ProductAssociationOldModelInterface[];
    up_sell?: ProductAssociationCardInterface[];
    previous_model?: ProductAssociationCardInterface[];
    add_on?: ProductAddOnCardInterface[];
}

export const mapOldModelToOlderModelAssociation = (
    item: ProductAssociationOldModelInterface,
): ProductOlderModelAssociationInterface => ({
    id: item.id,
    label: item.label,
    image: item.image,
    identifier: item.identifier,
    expirationYear: item.expirationYear
        ? {
              label: item.expirationYear.label ?? "",
              value: item.expirationYear.value ?? "",
          }
        : null,
});
